<template>
  <div class="info_form">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      :label-width="labelWidth"
      :inline="true"
    >
      <div class="block" v-for="(v, i) in formGroups" :key="`form${i}`">
        <div v-if="v.title" class="contit">{{ v.title }}</div>
        <FormItem
          v-for="(c, j) in v.formCtrl"
          :key="`formItem_${i}${j}_${c.keyName}_${!!c.disabled}`"
          :config="c"
          :disabled="c.disabled"
          :options="c.options"
          :viewMode="c.viewMode || viewMode"
          :inputValue="form[c.keyName]"
          @onChange="onChange"
          @onInput="onInput"
          @onSelect="onSelect"
        />
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "MyForm",
  props: {
    form: Object,
    rules: Object,
    labelWidth: String,
    formGroups: Array,
    viewMode: Boolean,
  },
  data() {
    return {};
  },
  methods: {
    onChange({ key, value }) {
      // console.log(key, value)
      // console.log(typeof value)
      this.form[key] = value;
      this.$emit("onChange", { key, value });
      // this.$forceUpdate()
      // console.log({ ...this.form });
    },
    onInput(o) {
      this.$emit("onInput", o);
    },
    onSelect(o) {
      this.$emit("onSelect", o);
    },
    validatePass(cb) {
      // console.log({ ...this.form });
      // console.log({ ...this.rules })
      // console.log(this.$refs)
      this.$refs["form"].validate((valid) => {
        // console.log(valid)
        if (valid) {
          cb(this.form);
        } else {
          console.log("验证不通过");
          console.log({ ...this.form });
          this.$message({
            type: "error",
            message: "请修改错误信息",
          });
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.info_form {
  padding-top: 20px;
  border-radius: 5px;
  background-color: #fff;
  // box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);

  .block {
    margin-bottom: 20px;

    .contit {
      height: 24px;
      line-height: 24px;
      overflow: hidden;
      margin: 0 auto 25px;
      padding: 0 21px;
      font-weight: bold;
      font-size: 18px;
      color: #343434;
    }
  }

  /deep/ .el-form {
    .el-form-item {
      padding: 0 20px 0 0;
      margin-bottom: 20px;

      &.unton {
        width: 1000px;
      }

      &.block {
        width: 100%;
        padding-right: 0;
        margin-right: 0;
      }

      .el-input,
      .el-textarea,
      .el-date-editor--daterange {
        width: 300px;
      }

      .el-form-item__content {
        .unit {
          color: #909399;
        }
      }

      .el-upload__tip {
        left: 107px;
        top: 2px;
        width: 150px;
      }

      // .el-button--small {
      //   padding: 13.5px 25.5px;
      // }
    }
  }
}
</style>
